export default "__VITE_ASSET__2ooFugqj__"